@if (abcSpinner.isLoading()) {
  <app-abc-spinner></app-abc-spinner>
}
<router-outlet></router-outlet>
<app-install-prompt></app-install-prompt>
<app-back-button></app-back-button>
@if (isValentineActive$ | async) {
  <app-valentine-particles></app-valentine-particles>
}
